import React from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit } from "src/componets/Buttons";
import { setEditId, PhnSubscriptionPlanInterface } from "src/store/callrecorder/phnSubscriptionPlansSlice";
import { EntityId } from "@reduxjs/toolkit";
import { formattedDate } from "src/helpers/DateHelpers";
import Pagination from "src/componets/Pagination";

import { Space, Tag } from "antd";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.callrecorder.phnSubscriptionPlans.ids);
  const plans = useAppSelector(state => state.callrecorder.phnSubscriptionPlans.entities);
  const count = useAppSelector(state => state.callrecorder.phnSubscriptionPlans.count);
  const data  = ids ? ids.map(id => plans[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  const renderActiveLabel = (active: boolean) => {
    if (active) {
      return <Tag color="success">active</Tag>
    } else {
      return <Tag color="default">inactive</Tag>
    }
  }

  const columns: ColumnsType<PhnSubscriptionPlanInterface> = [
    {
      key: 'name',
      title: 'Name',
      render: (_, { name }) => <small>{name}</small>,
      width: 120,
      ellipsis: true
    },

    {
      key: 'incoming_sms_limit',
      title: 'SMS Limit',
      render: (_, { incoming_sms_limit }) => <small>{incoming_sms_limit}</small>,
      width: 100
    },

    {
      key: 'active',
      title: 'Status',
      render: (_, { active }) => renderActiveLabel(active),
      width: 100
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => {
        return <small>{formattedDate(updated_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { id }) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
          </Space>
        );
      },
      width: 100
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
        search_keys={['name']}
        sort_keys={['incoming_sms_limit', 'created_at', 'updated_at']}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
